import { render, staticRenderFns } from "./ConvRequestForm.vue?vue&type=template&id=f9c72278&scoped=true"
import script from "./ConvRequestForm.vue?vue&type=script&lang=js"
export * from "./ConvRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c72278",
  null
  
)

export default component.exports